import { Link, useLocation, useNavigate } from "react-router-dom"
import DashboardSideBar from "../../components/dashboardSidebar"
import Footer from "../../components/footer"
import Header from "../../components/header"
import SideBar from "../../components/sidebar"
import { useEffect, useState } from "react"
import services from '../../services'
import Toaster from "../../components/toaster";
import useIsMobile from "../../hooks/useIsMobile";
import MobileFooter from "../../components/MobileFooter";
import MobileHeader from "../../components/MobileHeader";
import { missingProfileFields, hasReturnAfterProfile, takeReturnAfterProfile } from "../../utils/profileComplete";

const MyProfile = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const isMobile = useIsMobile();
    // Set when the customer was sent here to finish their profile before contacting a partner
    const completeReason = location.state?.reason || (hasReturnAfterProfile() ? 'Complete your profile to contact partners.' : null);
    const [firstName, setFirstName] = useState()
    const [lastName, setLastName] = useState()
    const [phoneNumber, setPhoneNumber] = useState()
    const [email, setEmail] = useState()
    const [gender, setGender] = useState()
    const [toaster, setToaster] = useState({ visiblity: "hide" });
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

    const updateProfileHandler = async() =>{
        if (completeReason) {
            const missing = missingProfileFields({ firstName, lastName, email, gender });
            if (missing.length) {
                setToaster({ type: "danger", title: "Complete your profile", text: `Please add your ${missing.join(', ')}.`, visiblity: "show" });
                setTimeout(() => setToaster({ visiblity: "hide" }), 3000);
                return;
            }
        }
        try {
            let payload = {
                firstName : firstName,
                lastName :lastName,
                email : email,
                phoneNumber : phoneNumber,
                gender: gender
            }
            console.log(payload)
           const response = await services.auth.UPDATE_PROFILE(payload) 
           console.log(response)
           let data = JSON.parse(localStorage.getItem('userDetails'));
           data.firstName = firstName;
           data.lastName = lastName;
           data.email = email;
           data.phoneNumber = phoneNumber;
           data.gender = gender;
           localStorage.setItem('userDetails', JSON.stringify(data))

           // Back to the one-way search they were on, which restores itself
           const returnTo = completeReason && takeReturnAfterProfile();
           if (returnTo) { navigate(returnTo); return; }

           setToaster({
            type: "success",
            title: "Profile update",
            text: 'Profile updated successfully',
            visiblity: "show",
        });
        setTimeout(()=>{
            setToaster({
                type: "danger",
                title: "Error",
                text: 'Error',
                visiblity: "hide",
            });
        },1500)
        } catch (error) {
            console.log(error)
            setToaster({
                type: "danger",
                title: "Error",
                text: 'Error',
                visiblity: "show",
            });
            setTimeout(()=>{
                setToaster({
                    type: "danger",
                    title: "Error",
                    text: 'Error',
                    visiblity: "hide",
                });
            },1500)
        }
    }

    const deleteAccountHandler = async () => {
        try {
            const response = await services.auth.DELETE_ACCOUNT();
            console.log(response);
            
            // Clear all local storage
            localStorage.clear();
            
            // Clear authorization header
            if (window.Axios) {
                window.Axios.defaults.headers.common["Authorization"] = "";
            }
            
            setToaster({
                type: "success",
                title: "Account Deleted",
                text: 'Your account has been deleted successfully',
                visiblity: "show",
            });
            
            setTimeout(() => {
                // Redirect to home page
                navigate('/');
                window.location.reload();
            }, 2000);
        } catch (error) {
            console.log(error);
            setToaster({
                type: "danger",
                title: "Error",
                text: error?.response?.data?.message || 'Failed to delete account. Please try again.',
                visiblity: "show",
            });
            setTimeout(() => {
                setToaster({
                    type: "danger",
                    title: "Error",
                    text: 'Error',
                    visiblity: "hide",
                });
            }, 3000);
            setShowDeleteConfirm(false);
        }
    };

    useEffect(() => {
        let data = JSON.parse(localStorage.getItem('userDetails'));
        if (data) {
            setFirstName(data.firstName)
            setLastName(data.lastName)
            setPhoneNumber(data.phoneNumber)
            setEmail(data.email)
            setGender(data.gender)
        }
    },[])
    if (isMobile) {
        const initials = `${(firstName || '').charAt(0)}${(lastName || '').charAt(0)}`.toUpperCase();
        const logout = () => { localStorage.clear(); window.location.replace('/'); };
        return (
            <>
                <Toaster type={toaster.type} title={toaster.title} text={toaster.text} visiblity={toaster.visiblity} />
                <SideBar />
                <main className="mlux">
                    <MobileHeader />

                    <div className="mlux-phero" data-rise="1">
                        <div className="pic">{initials || <i className="far fa-user"></i>}</div>
                        <div className="nm2">{firstName || 'Your name'} {lastName || ''}</div>
                        <div className="ph">+91 {phoneNumber || '—'}</div>
                    </div>

                    {completeReason && <div className="mlux-note" style={{ marginTop: 14 }}><i className="fas fa-circle-info"></i> {completeReason}</div>}
                    <div className="mlux-card" style={{ padding: 16, marginTop: 18 }} data-rise="2">
                        <label className="mlux-lbl">First name</label>
                        <div className="mlux-field no-icon"><input type="text" value={firstName || ''} placeholder="First name" onChange={(e) => setFirstName(e.target.value)} /></div>
                        <label className="mlux-lbl">Last name</label>
                        <div className="mlux-field no-icon"><input type="text" value={lastName || ''} placeholder="Last name" onChange={(e) => setLastName(e.target.value)} /></div>
                        <label className="mlux-lbl">Email</label>
                        <div className="mlux-field no-icon"><input type="email" value={email || ''} placeholder="you@email.com" onChange={(e) => setEmail(e.target.value)} /></div>
                        <label className="mlux-lbl">Gender</label>
                        <div className="mlux-field no-icon select"><select value={gender || ''} onChange={(e) => setGender(e.target.value)}><option value="">Choose gender</option><option value="male">Male</option><option value="female">Female</option><option value="other">Other</option></select></div>
                        <button className="mlux-btn" onClick={() => updateProfileHandler()}><i className="far fa-circle-check"></i> Save changes</button>
                    </div>

                    <button className="mlux-btn ghost" style={{ marginTop: 12 }} onClick={logout}><i className="far fa-arrow-right-from-bracket"></i> Log out</button>

                    {!showDeleteConfirm
                        ? <button className="mlux-danger" onClick={() => setShowDeleteConfirm(true)}><i className="far fa-trash-can"></i> Delete account</button>
                        : <div className="mlux-confirm">
                            <p>Delete your account permanently? This can't be undone.</p>
                            <div className="row2">
                                <button className="cancel" onClick={() => setShowDeleteConfirm(false)}>Cancel</button>
                                <button className="yes" onClick={() => deleteAccountHandler()}>Delete</button>
                            </div>
                        </div>}
                </main>
                <MobileFooter />
            </>
        );
    }

    return (<>
        <Header />
        <SideBar />
        <Toaster
            type={toaster.type}
            title={toaster.title}
            text={toaster.text}
            visiblity={toaster.visiblity}
        />
        <main class="main">
            <div class="user-profile py-5">
                <div class="container">
                    <div class="row">
                        <DashboardSideBar />
                        <div class="col-lg-9">
                            <div class="user-profile-wrapper">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="user-profile-card">
                                            <h4 class="user-profile-card-title">Profile Info</h4>
                                            {completeReason && <div className="alert alert-warning">{completeReason}</div>}
                                            <div class="user-profile-form">
                                             
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            <div class="form-group">
                                                                <label>First Name</label>
                                                                <input type="text" class="form-control" onChange={(e) => setFirstName(e.target.value)} value={firstName}
                                                                    placeholder="First Name" />
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <div class="form-group">
                                                                <label>Last Name</label>
                                                                <input type="text" class="form-control" onChange={(e) => setLastName(e.target.value)} value={lastName}
                                                                    placeholder="Last Name" />
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <div class="form-group">
                                                                <label>Email</label>
                                                                <input type="text" class="form-control" onChange={(e) => setEmail(e.target.value)} value={email} placeholder="Email" />
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <div class="form-group">
                                                                <label>Phone</label>
                                                                <input type="text" class="form-control" value={phoneNumber} disabled={true} placeholder="Phone" />
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <div class="form-group">
                                                                <label>Address</label>
                                                                <select  onChange={(e)=>setGender(e.target.value)} value={gender} className="select-custom">
                                                                    <option value>Choose Gender</option>
                                                                    <option value="male">Male</option>
                                                                    <option value="female">Female</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <button type="button" onClick={()=>{updateProfileHandler()}} class="theme-btn my-3"><span
                                                        class="far fa-user"></span> Save Changes</button>
                                              
                                            </div>
                                        </div>
                                        <div class="user-profile-card mt-4" style={{borderTop: '2px solid #dc3545'}}>
                                            <h4 class="user-profile-card-title" style={{color: '#dc3545'}}>Danger Zone</h4>
                                            <div class="user-profile-form">
                                                <p style={{color: '#666', marginBottom: '20px'}}>
                                                    Once you delete your account, there is no going back. Please be certain.
                                                </p>
                                                {!showDeleteConfirm ? (
                                                    <button 
                                                        type="button" 
                                                        onClick={() => setShowDeleteConfirm(true)} 
                                                        class="theme-btn" 
                                                        style={{backgroundColor: '#dc3545', borderColor: '#dc3545'}}
                                                    >
                                                        <span class="far fa-trash"></span> Delete Account
                                                    </button>
                                                ) : (
                                                    <div>
                                                        <p style={{color: '#dc3545', fontWeight: 'bold', marginBottom: '15px'}}>
                                                            Are you sure you want to delete your account? This action cannot be undone.
                                                        </p>
                                                        <div style={{display: 'flex', gap: '10px'}}>
                                                            <button 
                                                                type="button" 
                                                                onClick={deleteAccountHandler} 
                                                                class="theme-btn" 
                                                                style={{backgroundColor: '#dc3545', borderColor: '#dc3545'}}
                                                            >
                                                                <span class="far fa-trash"></span> Yes, Delete My Account
                                                            </button>
                                                            <button 
                                                                type="button" 
                                                                onClick={() => setShowDeleteConfirm(false)} 
                                                                class="theme-btn" 
                                                                style={{backgroundColor: '#6c757d', borderColor: '#6c757d'}}
                                                            >
                                                                Cancel
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-5 d-none">
                                        <div class="user-profile-card">
                                            <h4 class="user-profile-card-title">Change Password</h4>
                                            <div class="col-lg-12">
                                                <div class="user-profile-form">
                                                    <form action="#">
                                                        <div class="form-group">
                                                            <label>Old Password</label>
                                                            <input type="password" class="form-control"
                                                                placeholder="Old Password" />
                                                        </div>
                                                        <div class="form-group">
                                                            <label>New Password</label>
                                                            <input type="password" class="form-control"
                                                                placeholder="New Password" />
                                                        </div>
                                                        <div class="form-group">
                                                            <label>Re-Type Password</label>
                                                            <input type="password" class="form-control"
                                                                placeholder="Re-Type Password" />
                                                        </div>
                                                        <button type="button" class="theme-btn my-3"><span
                                                            class="far fa-key"></span> Change Password</button>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </main>
        {/* <Footer /> */}
    </>
    )
}
export default MyProfile